import React, {useEffect, useState} from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import DrawTable from '../../components/DrawTable';
import api from '../../core/api';
import moment from 'moment';
import {ReturnTypePremium} from '../../components/CampaingItem';

const ButtonExport = ({
  filterValue,
  subscriptionType,
  b2bFilter,
  adminSelect,
  newsletterType,
  onboardingUser,
  activeUser,
  platform,
  selectEmpresa,
  startDate,
  endDate,
}) => {
  const [dataExport, setDataExport] = useState([]);

  async function fetchUsers() {
    const filters = {
      name: filterValue,
      isAdmin: adminSelect,
      premium: subscriptionType,
      newsletter: newsletterType,
      onboarding: onboardingUser,
      activeUser: activeUser,
      platform: platform,
      business_id: b2bFilter,
      business_user: true,
      business_user_manager: false,
      company: selectEmpresa,
      startDate,
      endDate,
    };

    await api
      .get('users', {
        params: {
          page: 1,
          pageSize: 999999,
          filters,
          subscriptionType,
          searchInactive: true,
        },
      })
      .then(async ({data}) => {
        console.log('dados para export', data.users);
        setDataExport(data.users);
      })
      .catch(err => {});
  }

  useEffect(() => {
    fetchUsers();
  }, [
    filterValue,
    subscriptionType,
    b2bFilter,
    adminSelect,
    newsletterType,
    onboardingUser,
    activeUser,
    platform,
    selectEmpresa,
    startDate,
    endDate,
  ]);

  return (
    dataExport.length > 0 && (
      <>
        <ReactHTMLTableToExcel
          id="partners-table-xls-button"
          table="business-to-xls"
          className="MuiButtonBase-root MuiButton-root MuiButton-contained"
          filename={`relatorio_de_usuarios_de_empresas_${new Date()}`}
          sheet="tablexls"
          buttonText="RELATÓRIO DE USUÁRIOS EMPRESA"
        />

        <div style={{visibility: 'hidden', height: 10, width: '100%'}}>
          {DrawTable(
            [
              'Nome',
              'Email',
              'Departamento',
              'Telefone',
              'Plano(assinatura)',
              'Plano anterior',
              'Data cadastro',
              'Status',
              'Empresa',
            ],
            dataExport.map(user => [
              user.name,
              user.email,
              user.departament,
              user.phone,
              user.type_premium_b2b,
              '-',
              moment.utc(user.createdAt).format('DD/MM/YYYY') || '-',
              user?.is_active
                ? 'Ativo'
                : user.delete_date
                ? `Excluído  em ${moment
                    .utc(user.delete_date)
                    .format('DD/MM/YYYY')}`
                : 'Excluído',
              user?.business?.corporateName || '-',
            ]),
            'business-to-xls',
          )}
        </div>
      </>
    )
  );
};

export default ButtonExport;
